import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMHomeRoomView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      room: this.props.room,
    };
  }

  componentWillReceiveProps(nextProps) {
    let room = this.state.room;
    if (room != nextProps.room) {
      this.setState({room : nextProps.room});
    }
  }

  renderRoomPriceText(room){
    return SMFormatHelper.renderRoomPriceText(room, 'top');
  }

  render() {
    const room = this.state.room;
    const rank = this.props.rank;

    return(
      <div className="col-xs-4">
        <a href={Routes.space_room_path(room.space.username, room.uid)} className="a__top-units">
          <div className="md-top-units mdl-shadow--2dp">
            <div className="md-top-units__image">
              {(()=>{
                if (rank == null || rank >= 3) return;
                return (
                  <div className={`top-units-ranking units-ranking__no${rank + 1} units-ranking units-ranking__icon`}>
                    <div className="units-ranking__icon-body">
                      <span className="units-ranking__icon-number">{rank + 1}</span>
                    </div>
                  </div>
                );
              })()}
              <OptimizedImage
                src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490, crop: 'fill'})}
                alt={sprintf("%s の写真", SMFormatHelper.roomName(room))}
                className="md-top-units__image-pict" />
              {this.renderRoomPriceText(room)}
            </div>
            <div className="md-top-units__body">
              <div className="md-top-units__body-inner">
                <h3 className="md-top-units__body-title">{SMFormatHelper.roomName(room)}</h3>
              </div>
              <ul className="md-top-units__body-info">
                <li><i className="fa fa-user mr5"></i>{SMFormatHelper.capacity(room)}</li>
                <li><i className="fa fa-map-marker mr5"></i>{room.space.state_text}{room.space.city}</li>
              </ul>
            </div>
          </div>
        </a>
      </div>
    );
  }

}
export default SMHomeRoomView;



// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeRoomView.jsx